import { render } from "./create-follow.vue?vue&type=template&id=2da8af10&scoped=true&ts=true"
import script from "./create-follow.vue?vue&type=script&lang=ts"
export * from "./create-follow.vue?vue&type=script&lang=ts"

import "./create-follow.vue?vue&type=style&index=0&id=2da8af10&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da8af10"]])

export default __exports__